import { SCREENS } from "@sembark-travel/ui-theme"
import { createHooks, type Selector } from "@css-hooks/react"
export { pipe } from "remeda"

const conditions = {
	HOVER: "&:hover" as Selector,
	FOCUS: "&:focus" as Selector,
	ACTIVE: "&:active" as Selector,
}

export const media = {
	sm: `@media screen and (min-width: ${SCREENS.sm})`,
	md: `@media screen and (min-width: ${SCREENS.md})`,
	lg: `@media screen and (min-width: ${SCREENS.lg})`,
	xl: `@media screen and (min-width: ${SCREENS.xl})`,
} as const

const { on, and, or, not, styleSheet } = createHooks(
	conditions.HOVER,
	conditions.FOCUS,
	conditions.ACTIVE,
	media.sm,
	media.md,
	media.lg,
	media.xl
)

export { conditions, on, and, or, not, styleSheet }
